import React from "react";

import { FormTextAreaInput } from "@/uiKit/molecules/form/FormTextAreaInput.tsx";

export type InclusionReasonFormFieldProps = {
  name?: string;
  className?: string;
};

export const InclusionReasonFormField: React.FC<InclusionReasonFormFieldProps> = ({
  name = "inclusionReason",
  className,
}) => {
  return (
    <FormTextAreaInput
      id="inclusion-reason-form-field"
      name={name}
      className={className}
      reserveErrorSpace
      fullWidth
      minRows={2}
    />
  );
};
